export default __webpack_public_path__ + "8772e94f11cacc98c103a74534761c00.svg";